export const SITE_URL = "https://destinationroofinginc.com";
export const ROOFING_CONTRACTOR_ID = `${SITE_URL}/#roofingcontractor`;
export const OWNER_ID = `${SITE_URL}/about#deston-judy`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

export function canonical(path: string): string {
  if (path === "/") return SITE_URL + "/";
  return SITE_URL + path;
}
